define('controller/step/datetime/ClassesTimeStep',['require','controller/step/datetime/BaseDateTimeStep','collection/ClassesCollection','view/controller/booking/datetime/classes/TimeClassesView','view/controller/booking/datetime/classes/TimeClassesServiceListView','collection/TimeSlotCollection','view/controller/booking/datetime/classes/TimeClassesTimeSelectView','lib/view/ModalRegion','lib/view/BookingUrlBuilder','model/DayModel','Config'],function (require) {

    var BaseDateTimeStep = require('controller/step/datetime/BaseDateTimeStep');
    var ClassesCollection = require('collection/ClassesCollection');
    var TimeClassesView = require('view/controller/booking/datetime/classes/TimeClassesView');
    var TimeClassesServiceListView = require('view/controller/booking/datetime/classes/TimeClassesServiceListView');
    var TimeSlotCollection = require('collection/TimeSlotCollection');
    var TimeClassesTimeSelectView = require('view/controller/booking/datetime/classes/TimeClassesTimeSelectView');
    var ModalRegion = require('lib/view/ModalRegion');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
    var DayModel = require('model/DayModel');
    var Config = require('Config');

    return BaseDateTimeStep.extend({

        _timeCollection: null,
        _providerCollection: null,
        _serviceCollection: null,

        initialize: function () {
            BaseDateTimeStep.prototype.initialize.apply(this);

            this._predefined = Config.getInstance().getOption('predefined') || {};
            if(!_.isEmpty(this._predefined)) {
                this._bookingModel.set('r', true); //generate random r to trigger step change event
            }

            this.listenTo(this._stepManager, 'step:init:service', this.initServiceCollection);
            this.listenTo(this._stepManager, 'step:init:provider', this.initProviderCollection);

            this.listenTo(this._bookingModel, 'change:start_time', this.hideDialog);

            var serviceStep = this._stepManager.getStepObject('service');
            var providerStep = this._stepManager.getStepObject('provider');

            serviceStep.triggerInit();
            providerStep.triggerInit();
        },

        initProviderCollection: function (step, collection) {
            this._providerCollection = collection;
        },

        initServiceCollection: function (step, collection) {
            this._serviceCollection = collection;
        },

        /**
         * Updates exists view
         */
        refreshView: function () {
            this._updateFirstDay();
            this._handleModalDialog();
        },

        showServiceDialog: function () {
            if (!this._bookingModel.get('provider_id')) {
                return;
            }

            this._serviceCollection.performFilters();

            var view = new TimeClassesServiceListView({
                collection: this._serviceCollection,
                bookingModel: this._bookingModel
            });
            console.log('show showServiceDialog')
            this._getModalRegion().show(view);
        },

        showTimeDialog: function () {
            if (!this._bookingModel.get('service_id')) {
                return;
            }

            var collection = new TimeSlotCollection();

            collection.fetch({
                data: {
                    'skip_client_tz': true,
                    'from': this._bookingModel.get('start_date'),
                    'to': this._bookingModel.get('start_date'),
                    'location': this._bookingModel.get('location_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'count': this._bookingModel.get('count')
                }
            });

            var view = new TimeClassesTimeSelectView({
                bookingModel: this._bookingModel,
                collection: collection,
                serviceCollection: this._serviceCollection,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone')
            });
            this._getModalRegion().show(view);

            this.listenTo(view, 'nextAvailableDate', this._nextAvailableDate);

            setTimeout(function (){
                if( $('.modal-backdrop.fade.in').length == 0 ){
                    var cover = '<div class="modal-backdrop fade in"></div>';
                    $('body').append(cover);
                }
            }, 600);
        },

        _getModalRegion: function () {
            var modalRegion = new ModalRegion();
            
            //TODO handle clicking link to service's required membership (time_classes_modal_service_item_view.tpl: calling serviceBar non_link=true)
            this.listenTo(modalRegion, 'hide', this.resetSelectedData);

            return modalRegion;
        },

        resetSelectedData: function () {
            var _this = this;
            if (!this._bookingModel.get('start_time')) {
                var data = {
                    'service_id': null,
                    'provider_id': null,
                };

                this._predefined = Config.getInstance().getOption('predefined') || {};
                if(!_.isEmpty(this._predefined)) {
                    data.r = true; //generate random r to trigger step change event

                    ['service', 'provider', 'category', 'location'].forEach(function (key) {
                        if (_this._predefined[key]) {
                            data[key + '_id'] = _this._predefined[key];
                        }
                    });
                }

                this._bookingModel.set(data);

                var urlBuilder = BookingUrlBuilder.getInstance();
                Backbone.history.navigate(urlBuilder.buildUrl('booking_step', {}), {'trigger': true});
            }
        },

        hideDialog: function () {
            this._getModalRegion().hide();
        },

        _updateTimeCollection: function () {
            if (this._serviceCollection) {
                this._serviceCollection.performFilters();
            }
            if (this._providerCollection) {
                this._providerCollection.performFilters();
            }

            return BaseDateTimeStep.prototype._updateTimeCollection.apply(this, arguments);
        },

        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new ClassesCollection();
        },

        /**
         * Returns time view
         *
         * @return TimeClassesView
         */
        _getTimeView: function () {
            var view = new TimeClassesView({
                providerCollection: this._providerCollection,
                serviceCollection: this._serviceCollection,
                classesCollection: this._timeCollection,
                bookingModel: this._bookingModel,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                waitingListHelperModel: this.getOption('waitingListHelperModel'),
            });

            this._handleModalDialog();

            return view;
        },

        _handleModalDialog: function () {
            if (this._bookingModel.get('provider_id')) {
                if (this._bookingModel.get('service_id')) {
                    if (!this._bookingModel.get('start_time') && this._bookingModel.get('start_date')) {
                        this.showTimeDialog();
                    }
                    if (!this._bookingModel.get('start_date')) {
                        this._bookingModel.set({
                            'provider_id': null,
                            'service_id': null
                        });
                    }
                } else {
                    this.showServiceDialog();
                }
            } else {
                this._getModalRegion().hide();
            }
        },

        //NB copied from BaseDateTimeStep, but with specific provider/service handling
        _nextAvailableDate: function () {
            var currentDate = this._bookingModel.get('start_date');
            var _this = this;

            var nextDayModel = new DayModel({
                url: '/booking/next-working-day',
            });

            nextDayModel.fetch({
                data: {
                    'date': currentDate,
                    'location': this._bookingModel.get('location_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'count': this._bookingModel.get('count'),
                    'timeline': Config.getInstance().getOption('timeline_type')
                },
                success: function (model) {
                    if (!model.get('date')) {
                        return;
                    }
                    var date = Date.parseMysqlDate(model.get('date'));

                    _this._bookingModel.set({
                        'start_date': date.getMysqlDate(),
                        'provider_id': null,
                        'service_id': null
                    });
                    _this._updateCalendarCollection(date.getMysqlDate());

                    _this._getModalRegion().hide();

                    var url = BookingUrlBuilder.getInstance().buildUrl('booking_step', {
                        'date': model.get('date'),
                        'provider': null,
                        'service': null
                    });
        
                    if (!model.skipNavigationOnCalendar) {
                        Backbone.history.navigate(url);
                    }
                }
            });
        }

    });

});
